import React from 'react';
import { I18n, Trans } from 'react-i18next';

import $ from 'jquery';
import Waypoint from 'react-waypoint';


export class CommentMarche extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      animated: false
    }

    this._handleEnter = this._handleEnter.bind(this);
  }

  componentDidMount(){

  }

  _handleEnter() {
      var _ = this;

     // alert("comment");
     
      if(!this.state.animated) {
        setTimeout(function() {
          $('.center-phone').removeClass('fade');
        $('.center-phone').addClass('animated slideInUp');
        $('.mobile-info:nth-child(2),.mobile-info:nth-child(3)').addClass('animated slideInDown delay1s');
        $('.mobile-info:nth-child(4),.mobile-info:nth-child(5)').addClass('animated slideInDown delay2s');
        $('.mobile-info:nth-child(6),.mobile-info:nth-child(7)').addClass('animated slideInDown delay3s');


        setTimeout(function() {
             $('.mobile-info:nth-child(2),.mobile-info:nth-child(3)').removeClass("fade") 
         }, 1000); 
        setTimeout(function() {
             $('.mobile-info:nth-child(4),.mobile-info:nth-child(5)').removeClass("fade") 
         }, 2000); 
        setTimeout(function() {
             $('.mobile-info:nth-child(6),.mobile-info:nth-child(7)').removeClass("fade") 
         }, 3000); 

          jQuery('#image-fade1').cycle();

          _.setState({animated: true});

        },0);
      }
  }
  render() {
    
    return (
     <I18n ns="translations">
        {
          (t, { i18n }) => (    
          <Waypoint onEnter={this._handleEnter} bottomOffset="75%">   
                 <section id="bottom-section">
                  <div className="container-fluid">
                      <div className="row">
                    
                        <div className="col-md-12 col-sm-12 col-xs-12 text-center top-text ">
                          <h1>{t('commenttitle')}</h1>
                          <h4>{t('commentHead')}</h4>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-2 col-md-push-5 col-xs-12 text-center ">
                          


                        <div id="image-fade1" className="center-phone fade">
                             <img src="../../images/ecrans_arrondis_01.png" />
                             <img className="" src="../../images/sur_mesure_01.png" />
                             <img className="" src="../../images/ecrans_arrondis_12.png" />
                             <img className="" src="../../images/sur_mesure_02.png" />
                        </div>     

                        </div>
                        <div className="col-md-5 col-md-pull-2 col-xs-12 mobile-info fade">
                          <div className="row">
                              <div className="col-md-3 col-md-push-9 col-sm-3 col-xs-4 res text-center fr">
                                  <img className="zig-zag-img" src="images/mobile_ic-cerne.png"/>
                                </div>
                               <div className="col-md-9 col-md-pull-3 col-sm-9 col-xs-8 res tr">
                                 <div className="zig-zig-content">
                                   <h3><b> {t('commentlefth1')}</b></h3>
                                    <h4>{t('commentleftl1')}<span className="res-block"> {t('commentleftl2')} </span>{t('commentleftl3')}</h4>
                                 </div>
                                </div>
                                
                          </div>
                        </div>
                        <div className="col-md-5 col-xs-12 mobile-info fade">

                          <div className="row">
                            <div className="col-md-3 col-sm-3 col-xs-4 res text-center">
                              <img className="zig-zag-img" src="images/mobile_ic-etoile.png"/>
                            </div>
                             <div className="col-md-9 col-sm-9 col-xs-8 res">
                                <div className="zig-zig-content">
                                  <h3><b>{t('commentrighth1')}</b></h3>
                                  <h4>{t('commentrightl1')}</h4>
                                </div>
                            </div>             
                          
                          </div>
                        </div>
                        <div className="col-md-5 col-md-pull-2 col-xs-12 mobile-info fade">

                          <div className="row">
                          <div className="col-md-3 col-md-push-9 col-sm-3 col-xs-4 res text-center fr">
                              <img className="zig-zag-img" src="../../images/mobile_ic-loupe.png"/>
                            </div>
                            <div className="col-md-9 col-md-pull-3 col-sm-9 col-xs-8 res tr tr-pad">
                                <div className="zig-zig-content">

                                  <h3><b>{t('commentlefth2')}</b></h3>
                                  <h4>{t('commentleftl4')}</h4>
                              </div>
                            </div>               
                          
                          </div>
                        </div>
                        
                        <div className="col-md-5 col-xs-12 mobile-info fade">
                          <div className="row">
                             <div className="col-md-3 col-sm-3 col-xs-4 res text-center">
                              <img className="zig-zag-img" src="../../images/mobile_ic-coeur.png"/>
                            </div>
                            <div className="col-md-9 col-sm-9 col-xs-8 res pad">
                              <div className="zig-zig-content">

                                <h3><b>{t('commentrighth2')}</b></h3>
                                <h4>{t('commentrightl2')}</h4>
                              </div>
                            </div>
                            

                          </div>
                        </div>
                        <div className="col-md-5 col-md-pull-2 col-xs-12 mobile-info fade">

                          <div className="row">
                              <div className="col-md-3 col-md-push-9 col-sm-4 col-xs-4 res text-center fr">
                                <img className="zig-zag-img" src="../../images/mobile_ic-photo.png"/>
                              </div>
                              <div className="col-md-9 col-md-pull-3 col-sm-8 col-xs-8 res tr">
                                <div className="zig-zig-content">

                                  <h3><b>{t('commentlefth3')}</b></h3>
                                  <h4>{t('commentleftl5')}</h4>
                                </div>
                              </div>
                              


                                      
                          </div>
                        </div>
                        <div className="col-md-5 col-xs-12 mobile-info fade">

                          <div className="row">
                            <div className="col-md-3 col-sm-3 col-xs-4 text-center res">
                              <img className="zig-zag-img" src="../../images/mobile_ic-caddie.png"/>
                            </div>
                            <div className="col-md-9 col-sm-9 col-xs-8 res">
                               <div className="zig-zig-content">

                                <h3><b>{t('commentrighth3')}</b></h3>
                                <h4>{t('commentrightl3')}</h4>
                              </div>
                            </div>
                            


                          </div>
                        </div>
                      </div>
                      <div className="row">
                         <img id="bottom-section-img" src="../../images/designed-line-200.png"/>
                      </div>
                  </div>
              </section>
              </Waypoint>
            )
          }
      </I18n>
     
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/CommentMarche/CommentMarche.js